var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.visitLabel || _setup.address
    ? _c(
        "footer",
        {
          staticClass:
            "review-card-footer d-flex text-body-2 text-secondary--text",
          class: _setup.isMobile
            ? "flex-wrap ga-2"
            : "review-card-footer--desktop align-start",
        },
        [
          _setup.visitLabel
            ? _c(
                "div",
                {
                  staticClass:
                    "review-card-footer__visit d-flex align-center flex-shrink-0",
                },
                [
                  _c("span", {
                    staticClass: "ui-icon-calendar-none ui-icon-fz-medium mr-2",
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n      " +
                        _vm._s(_setup.tStatic("Приём был в")) +
                        "\n      " +
                        _vm._s(_setup.visitLabel) +
                        "\n    "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _setup.address
            ? _c("div", { staticClass: "review-card-footer__address" }, [
                _vm._v("\n    " + _vm._s(_setup.address) + "\n  "),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }